export const login = {
  assetTrackingUtilizationReports: "资产追踪和利用报告",
  cloudManagementSystem: "云管理服务",
  companyName: "公司名称",
  digitizeInspectionReports: "数字化的点检报告",
  doNotHaveAnAccount: "没有账号？",
  failedToSignIn: "登录失败",
  failedToSignInPleaseRetry: "登录失败，请重试",
  forgotPassword: "忘记密码？",
  loginToWorkXConnectCloud: "登录WorkX Connect Cloud",
  noUserCompanyTip: "电子邮箱未注册",
  phoneNumber: "@:common.user.phoneNumber",
  password: "密码",
  pleaseInputYourPassword: "请输入密码",
  privacyPolicy: "隐私政策",
  signIn: "登录",
  signUpToday: "立刻注册",
  unlimitedVideoUploads: "不限次的视频上传",
  userEmailNotActivatedTips: "请点击通知邮件中的链接，激活您的账号。",
  userSignIn: "用户登录",
  VIAWorkXConnect: "威盛云管家",
  pleaseInputYourPhoneNumber: "请输入手机号",
  digitizeReports: "协助企业管理数字化转型",
  boostOperationalEfficiency: "智能化升级提升运营效率 ",
  assetsTrackingAndUtilizationReports: "优化流程提升效能",
  easyToGetStarted: "易装易用高效安全",
  loginToVIAWorkXConnect: "登录威盛云管家",
  hasNoPermissionToLogin: "您无权限访问，请联系管理员",
  miniProgram: "- 威盛车管家微信小程序 -",
};
